module.exports = __webpack_public_path__ + "img/footer-1-at.beac8980.png";